// extracted by mini-css-extract-plugin
export var notificationHost = "_cl-0";